import { FatActiveInvestmentsPageInvestmentManagersQuery } from '@/__generated__/graphql';
import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import useStickyFooter from '@/hooks/useStickyFooter';
import { useRef } from 'react';
import styled from 'styled-components';
import { managersColumns } from '../constants';
import MobileTable from './mobileTable';
import TableBody from './tableBody';
import TableSumFooter from './tableSumFooter';

interface TableProps {
  tableData: FatActiveInvestmentsPageInvestmentManagersQuery['InvestmentManagers']['managers'];
  sort: ISort;
  setSort: (value: ISort) => void;
  refetch: () => void;
  loading: boolean;
  handleManagerClick: (name: string) => void;
}

const ManagersTable = ({ tableData, sort, setSort, refetch, loading, handleManagerClick }: TableProps) => {
  const { isMobile } = useResponsive();

  const containerRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);

  useStickyFooter(containerRef, footerRef);

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <MobileTable columns={managersColumns} tableData={tableData} handleManagerClick={handleManagerClick} loading={loading} />
          )}
        </>
      ) : (
        <>
          <TableHeader refetch={refetch} columns={managersColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <>
                <TableBody tableData={tableData} handleManagerClick={handleManagerClick} />
                <TableSumFooterWrapper ref={footerRef}>{<TableSumFooter tableData={tableData} />}</TableSumFooterWrapper>
                <div ref={containerRef}></div>
              </>
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default ManagersTable;

const TableSumFooterWrapper = styled.div`
  &.sticky {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
`;
